import LeaderboardScreen from "@/src/screens/leaderboard/leaderboard";

export default function LeaderboardRoute() {
  return <LeaderboardScreen />;
}
